<template>

<app-wrapper class="page">

	<app-wrapper v-if="!blank" class="page-banner" :style="{backgroundImage: banner}" />
	
	<app-wrapper v-if="!blank && title" class="page-title" :class="{'with-description': description}">

		<app-inner>

			<h1>{{ title }}</h1>

			<app-text v-html="description" :center="true" />

		</app-inner>

	</app-wrapper>

	<app-wrapper class="page-content">

		<slot></slot>

	</app-wrapper>

</app-wrapper>

</template>

<script>

export default {

    props: ['title', 'description', 'blank'],
    
    computed: {

        banner: function() {

            return (this.page.banner) ? 'url(' + this.page.banner + ')' : false

        }

    }

}

</script>

<style scoped>

.page-banner {
	height: 240px;
	background-color: var(--color-blue-light);
    background-position: 50% 50%;
    background-size: cover;
}

.is-tablet .page-banner {
    height: 180px;
}

.is-mobile .page-banner {
    height: 120px;
}

.page-title {
	padding-top: 40px;
}

.is-mobile .page-title {
    padding-top: 20px;
}

.page-title h1 {
	text-align: center;
	color: var(--color-grey-dark);
	font-size: 32px;
	font-family: "grueber",serif;
}

.is-mobile .page-title h1 {
    font-size: 24px;
}

.page-title.with-description h1 {
	margin-bottom: 20px;
}

.page-content {
	padding: 40px 0px;
}

.is-mobile .page-content {
    padding: 20px 0px;
}

</style>